import React from 'react'
import clx from 'classnames'
import _ from 'lodash'
import { Icon, Button } from '@vzmi/shp_shared_compo'
import Popover from '../../../../Common/Popover'
import styles from '../index.css'
import { getAttrMap } from '../helpers'

const VisibleButton = props => {
  const { record, isTwoLayerAttr, onClick, readOnly, className } = props
  const attrMap = getAttrMap(isTwoLayerAttr)
  const isVisible = _.get(record, attrMap.specVisible)
  const visibleBtnTip = isVisible
    ? '點擊可在賣場頁隱藏此項目'
    : '點擊可在該賣場重新顯示此項目'
  return (
    <Popover content={visibleBtnTip}>
      <Button
        buttonType='outline'
        size='small'
        className={clx(
          styles.actionBtn,
          styles.visibleBtn,
          { [className]: className },
          { [styles.invisibleStatus]: !isVisible },
          { [styles.disableBtn]: readOnly }
        )}
        onClick={onClick}
        readOnly={readOnly}
      >
        <Icon
          name='visible'
          color='#979ba7'
          align='middle'
          size={16}
          unallowed={!isVisible}
        />
      </Button>
    </Popover>
  )
}

export default VisibleButton
